var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnarchiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 1.25C15.5 0.835786 15.8358 0.5 16.25 0.5H21.75C22.1642 0.5 22.5 0.835786 22.5 1.25V6.75C22.5 7.16421 22.1642 7.5 21.75 7.5C21.3358 7.5 21 7.16421 21 6.75V3.06066L14.7803 9.28033C14.4874 9.57322 14.0126 9.57322 13.7197 9.28033C13.4268 8.98743 13.4268 8.51256 13.7197 8.21967L19.9393 2H16.25C15.8358 2 15.5 1.66421 15.5 1.25Z",
    fill: "#24292E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 3C2.11193 3 2 3.11193 2 3.25V15.75C2 15.8881 2.11193 16 2.25 16H4.75C5.16421 16 5.5 16.3358 5.5 16.75V19.9393L9.21967 16.2197C9.36032 16.079 9.55109 16 9.75 16H19.75C19.8881 16 20 15.8881 20 15.75V9.75C20 9.33579 20.3358 9 20.75 9C21.1642 9 21.5 9.33579 21.5 9.75V15.75C21.5 16.7165 20.7165 17.5 19.75 17.5H10.0607L6.48744 21.0732C6.21418 21.3465 5.84356 21.5 5.45711 21.5C4.65237 21.5 4 20.8476 4 20.0429V17.5H2.25C1.2835 17.5 0.5 16.7165 0.5 15.75V3.25C0.5 2.2835 1.2835 1.5 2.25 1.5H13.25C13.6642 1.5 14 1.83579 14 2.25C14 2.66421 13.6642 3 13.25 3H2.25Z",
    fill: "#24292E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchiveIcon);
export default __webpack_public_path__ + "static/media/unarchive-icon.8fe35a0d.svg";
export { ForwardRef as ReactComponent };